var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-cy":"date-field"}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.data)))])}
var staticRenderFns = []

export { render, staticRenderFns }